import en from "./locales/en.json";
import arJson from "./locales/ar.json";
import type { TranslationKey } from "./keys.gen";

const ar: Partial<Record<TranslationKey, string>> = arJson;

export const translations = { en, ar } as const;

export type Locale = keyof typeof translations;
export type { TranslationKey };
